export const YOUTUBE_SEARCH_API_URL =
    'https://www.googleapis.com/youtube/v3/search';
export const YOUTUBE_VIDEO_API_URL =
    'https://www.googleapis.com/youtube/v3/videos';
export const YOUTUBE_CHANNEL_API_URL =
    'https://www.googleapis.com/youtube/v3/channels';
export const YOUTUBE_CREATE_ORDER_PATH = ['/youtube/create-order'];
export const YOUTUBE_SELECT_POST_PATH = ['/youtube/select-post'];
export const YOUTUBE_COMPLETE_ORDER_PATH = ['/youtube/complete-order'];
export const YOUTUBE_PATHS = [
    '/youtube',
    '/youtube/create-order',
    '/youtube/select-post',
    '/youtube/complete-order',
];
export const YOUTUBE_VIDEO_REGEX =
    /http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-_]*)(&(amp;)?[\w?=]*)?/;
export const YOUTUBE_CHANNEL_REGEX =
    /((http|https):\/\/|)(www\.|)(m\.|)youtube\.com\/(channel\/|user\/|c\/|@)[a-zA-Z0-9_-]{1,}/;

export const YOUTUBE_API_KEYS = [
    'AIzaSyBPJmovoh6I2GhR0zHPeVBO3UT3_Tc0Rdk',
    'AIzaSyBR_zt3JsZjkoWnSEOgTbPI3I1G047bcjU',
    'AIzaSyCQvMiVFGSDrVN45bqCuF5ZH-M8UdYCnIM',
    'AIzaSyCscx1NL2L7ZwB1dhbq_NPymdbDssxGdeg',
    'AIzaSyB_5NziFxe8uWUdbQPxJ8mOI98IF7VkJ-I',
    'AIzaSyDPFw_pbhcxT7FpVFZtiPe4B6wV--yqF8c',
    'AIzaSyAg9Ng8C9eWr2hUDEadjkrx7cYiIO-lVK0',
    'AIzaSyCJGYztqYdUujNrhk1iFMeXNPdqneR_mUQ',
    'AIzaSyDSL_0BCvGfgfAQQmPcYFqoTMHhlmBd-Ew',
    'AIzaSyCe2p95vpo2eLRf-1cCu7gmPp7CI_5YJzc',
    'AIzaSyBdjcbxCEx3UPaBXrTElOzT5fqnTug-rk0',
    'AIzaSyCHohe0sWDOlh-3RYlO4dKq6KuLCLCrcLw',
    'AIzaSyDcTWE7FT-mizQ6Im1OE7Gm2WooO1vQW-c',
    'AIzaSyBgN8D86Zsz6FRtYLYzWtYqbLmSPUOMAB0',
    'AIzaSyAtA90jjfeY3KtDHdleLopmglP0VmSRI-Y',
    'AIzaSyDQ4G-_vxxcC--GBDO6nasnslsW-qnDhAw',
    'AIzaSyBzczG7HHHAd1e4jBYbiPDAUEg-ZnsIFVw',
    'AIzaSyCtGhe6YyGK3q3CMDT3DG2sIGrvyOaFS-I',
    'AIzaSyAz7qAc1YDp_pdC0MS_MHMkdlWhObvoeoE',
    'AIzaSyAbOFa70C0AWUAEPzX_9IwziwVLn5EXiAo',
    'AIzaSyDRtpznzIES1gOnGXOvutAbkv4EMSABNwI',
    'AIzaSyCz7KuqO1Dp3c0Yi186NLU7-m2vA_c_C88',
    'AIzaSyAJo1qsDZvAR4j7TtQN5B8Fuwfl-s9FxYg',
    'AIzaSyCm-kur8HoDX9D87132UHhgR0n8I9wa8Dg',
    'AIzaSyBtD50hQVbiuV0RP32ETVzGPZBvBSObUbA',
    'AIzaSyAM3SDfm3GmyRULD3_8yy42CrypM_CyKF0',
    'AIzaSyB3Ch7pDjhAPYKWeMZRDg0Vp_m58eRsdhg',
    'AIzaSyDWCHxu2XOUHJrmOLQIFv95zdJES2KZqtg',
    'AIzaSyD306oz4lnaR6C1ZuS32fYOiZkZug4JjTk',
    'AIzaSyBWHCX9Lj06GAwe7g2WY2DeZ0vA4stbh5I',
    'AIzaSyCYJPhv0app_6kjoBXtOCtElEzMXmtPRBk',
    'AIzaSyDyEPSdOH5uFD7sJcwgA0-g07SNKhGS6qU',
    'AIzaSyCfGYpqoLgWu9kZFQmU09IAuXH_DAp5as8',
    'AIzaSyCtT8CPQ1wfhtCXoVIpF6ZZRBhuXX_5eeQ',
    'AIzaSyCh9qCPDezzVM5Toooe_tGoh7_jFHKgxx8',
    'AIzaSyC43y2V6fONhwFSYgTG-VyvwSg8YD2LCwA',
    'AIzaSyBpZLflV6ErAC_ev3W_AjHIw7BB7qvtlog',
    'AIzaSyDcknQt7Q4YzL0-qHotlaS3eZaR9-vTFKc',
    'AIzaSyCzaJQBW2wvkh9WM5wT6dsx2I3XUc2zltI',
    'AIzaSyDqVN6yc1Km4MdF1yl5zxnlGDOwAiDf_W0',
    'AIzaSyBfzsmLWNxKz488PLAwN7fg1_xOmNZTKzw',
    'AIzaSyDhY0d-FZmLrW5oL1d-c9Lyx7nSoVAwY4A',
    'AIzaSyBS7DWWC-XKUfBsueNFepEuQobtAuoFDHg',
    'AIzaSyCw3rMqm9N5YvJRAytNaNwcMnSXc5UX0Pc',
    'AIzaSyCzKQnY0Q98pEf5qk4NuFYZniCuqjm-TcM',
    'AIzaSyB1mlGKhEHQDcVkF8A5jxubon7I7GIkkNU',
    'AIzaSyCqG-d88YZIjHgRvjdZHHfXdKGVSg43h0Y',
    'AIzaSyDQ8sNLO8womL-0S7ZUA4t4-FPNL5UaDFE',
    'AIzaSyAoB7f0dcDIvnQeIqV28_gFSqBcrvghBlQ',
    'AIzaSyCUg0rt1JRbYkEsWSrExjEXU9zgyIhkO-g',
    'AIzaSyCFmnalkmWbz4lWm3HPwECOILzUeG0tfcw',
    'AIzaSyDXajO5qaj2NF0mQoMUj4XhbOoSGByrbGk',
    'AIzaSyAzjSEioKJ-y4rmIs7KaNNcC5RB7WRVCuo',
    'AIzaSyBwHCBHNOETrP7l-Hjv5xW6_G5Kp3-HqOk',
    'AIzaSyCR4cyXZKW_nMQRA3KE_IW7Jqtk_SE8tww',
    'AIzaSyAc40TlaZgvAzm2sVL9P24Gou3Nk2ppLPw',
    'AIzaSyD7iBR95_7ebck4phhpEf_s_cCARsSjLDw',
    'AIzaSyDWTuSpVji02bb8GoGybTc2GCdKZAgQYd4',
    'AIzaSyAZPAJhvfg7CNXlO-jcIe_1BGylNbQLTNI',
    'AIzaSyDZmHUw64SqHqDPdSEyEK2Nlbj5WplwqBQ',
    'AIzaSyA_vupXVqoVa-5MW99tsee3V8fML1HdOgQ',
    'AIzaSyAxNmYtjcs0eLaboqk_AaAB8XHl9og9XMw',
    'AIzaSyDfONOyWBBF0E34AKyrXO8S3x0GTHDhXBY',
    'AIzaSyChugoxignV9-Hnd1btgYMEfjUa8LU3r2M',
    'AIzaSyC1NfUxXEiA_PwW8w0kzPGbkH6vpN0eTgo',
    'AIzaSyCegqRg57z4r6CLWzT-MeLhiuOVIL9quUw',
    'AIzaSyCPcWqW_PnAgifH_lD7Uy3hoSvzMTWr3Gc',
    'AIzaSyB9W7FEGZC7BMnMLADZ1cgE_7j5Ui5oQpo',
    'AIzaSyBZl-QlFctmgkgNXBpfYS-yf2M4xQ7JdJ4',
    'AIzaSyBcZG-7u1lwDi6wnGriv4GMeoFxRIB9gl0',
    'AIzaSyBdm8zLTpz4t3YASzfC2YKUdLp44zZtwpc',
    'AIzaSyCNPm7rCtmNvkvWfXGDbGXYA5UxUNEknMY',
    'AIzaSyCCMEsUi5SE21Ksp9kTbiOcZ9BEuhGoEa4',
    'AIzaSyDVBmNA0ZvVxFrrdIH3IrjipUP3zPL0HvI',
    'AIzaSyCdEx75r-j8zn4_9kYOdt1dTRhDor11Dao',
    'AIzaSyCH4YRCeW5v9uVZKh-MdFHaJ6hHhFYGMUc',
    'AIzaSyDl4TqUfd_0Kryb05CihfytjoK67R7stqw',
    'AIzaSyDTtrWRFJNI6kwUmbyg_NY1FtfCCJ9vFzI',
    'AIzaSyAy_LYvxsBdgKNJVMF0OREDBczlFIm-IIk',
    'AIzaSyCIvrL2soAF6T1e-StfsNEd0F7wjyypGFA',
    'AIzaSyDkyYzFTZoRxOGSgst0dHeO4FokA34F8kE',
    'AIzaSyBnVhdJN-c6HMerkbplN8NbBG2EZzOXtzU',
    'AIzaSyBDgtUZm7yxt4fMV2xHbtXkDa2sSwEbCDg',
    'AIzaSyBAPSXF7Ropa7EbUueqNdkiZq47zWwIVKw',
    'AIzaSyCHJnGaKdTcX50MEnOQ2N_nKC5robXW1X8',
    'AIzaSyBGPGl9l6QpKq8EOlMUPuK9NBY5OgWVqMQ',
    'AIzaSyD_LFHIAgIYNnn0BuXbumcVkTVan3wD5Ro',
    'AIzaSyBYmeKW1L09yU808316-lSmubMEZ20j0dA',
    'AIzaSyCefdCHQb3iAF9-fY0ZE7-CIGkACr7dDSQ',
    'AIzaSyB2yl8B9oOhQtBkNp1bFu2cJJdutLNGo14',
    'AIzaSyAhNFpP91dLWktr1biqA0RUtC83I_MSFR0',
    'AIzaSyCHKkkBwW3onclro6_kST3JwJCz9jIRiFE',
    'AIzaSyABo80b4T8Tjd-CTsv771VpIZ_B3fvSgnc',
    'AIzaSyDtRGm156M9Y3AUHu_xomaE4gdy3WTd1o8',
    'AIzaSyB9ZQgdQ0ulRDBhGH2kZ0jBPStP5r-1KBA',
    'AIzaSyBcPBRwi9K7VUxdW4qp2xotGr0j245wH98',
    'AIzaSyCcds4L8Q76xB9Myflcoypv1ey_5PL06lI',
    'AIzaSyDQrKDidBtU9z2hPTwSV3DoGXjGyNarYYA',
    'AIzaSyDaq9TGS2aH5GrGZyDJAR6L_hmvr0BNx0E',
    'AIzaSyBoUeWx7eTxPeGv3HEPkmvm5ZXa3yWa9v8',
    'AIzaSyBmWYWK64B7df5UkadTtHl_U6aGeJy5Hcg',
    'AIzaSyDCUCaf7tsDjvY4mYqvqvFZ3NvfZpTbRZE',
    'AIzaSyAljDf-2-8x0FIr5UvJHE9Yaqq5qjuhOlk',
    'AIzaSyDYCPKkQrXbIhl6vdVDQbRywXyNmEOcPAQ',
    'AIzaSyBr4nSJFBNYtwUQdeXX76-mCWoItGp0nwg',
    'AIzaSyBx6zjlzutNvbRMZGTcjYovbnuSpAQszwk',
    'AIzaSyCrP7V9fRxJEhtqeWwliuCHtmwBuOFXg5M',
    'AIzaSyByL40w9vfX51rm8Fl-UXmkkiWBb4C1oqM',
    'AIzaSyDReVmttKVzLVldFhqqJK4Dqyb8Laio6TE',
    'AIzaSyDUhjZ_omGsqrG2YDA4exZqLNqdvqCpVKw',
    'AIzaSyCs6DU34QKpn8unTMgv4pXMIW_vjDxxPxc',
    'AIzaSyC0EWdbc5s5OAO63UCNxmGruvzgv2GTBxQ',
    'AIzaSyC-pNk_PLS8vlMZNCivxViA47AXnBlFnJQ',
    'AIzaSyBttaaTNvAVKxNFCOB4SClfU2VHkxY7X4s',
    'AIzaSyDWRNexgEH7S0kSAKKpl5xsvolVXpt1bRY',
    'AIzaSyAg-08sqRBFLUf9xZDPu9GK5lgPSt9-gH0',
    'AIzaSyBwrlTQAV_nJ67RgRqcCjEoqgLj8sWtkw8',
    'AIzaSyCgDK1MhUrsiRCRhHNq_20gP627yGkdrHA',
    'AIzaSyD4FDdEqkfT5dBIgfp0qfh0c_PpZ0GB6n4',
    'AIzaSyAIjEAGWSexfe42Koy3gFDlTKPbQdiQefc',
    'AIzaSyDcNR_doEYosxE6rm00mEBOtLc4ptpb5oI',
    'AIzaSyBlkAIvdqbJ61VxYrVwYP-eOz-0J9QfJt0',
    'AIzaSyABd9LOcXVzt4GVVzts7iJjmwcuQXVpSao',
    'AIzaSyBuuj4rNdQTmbDYhjOGk_gRUtcLORdOOvg',
    'AIzaSyA95uhDaOnm3fcyXA8I34rIFwzOYgHQCbQ',
    'AIzaSyA_3b0mCeZhwNMNYLmOo3G_II0USxL7niI',
    'AIzaSyBZIgLQg2E2VVv-QKZYTiJsQjQj0j69BpU',
    'AIzaSyCiFwxxfiuJXVTzM1chb0NrT76S1EKkuqo',
    'AIzaSyDONp4II4ewzQNJcdNfaQH1K6EQG0U_t3Q',
    'AIzaSyDUBOz0Sx3ubO2YGgYF4BqjAc_ioHjGaWs',
    'AIzaSyB371WUf4hfpcInztat7cGKDZkqewxcDNU',
    'AIzaSyBWTJi1zbUPxu5faa60w5ENdmFc3LOqMyU',
    'AIzaSyAKsAwxRZcDYgk-TEFSLoKCH5d3E-O4zR0',
    'AIzaSyBE2JN7WG6YI3H3iJD81xo3KW4ud_ll2mM',
    'AIzaSyACv_J--SB9UiUePpegzAUOkjO0d3xnrEA',
    'AIzaSyCC4SX7iAMkbiFVdc0qk5tU1qj0Qz7UWDw',
    'AIzaSyBHh64vsO1RWZkUMfnJg6e8GmWY3gfz7pc',
    'AIzaSyCKOVre8Epl8WaU-BHtzpo3HGmjClAIlnM',
    'AIzaSyDojMN536H9XZ-O2UZMeMhux9VrQ_YZhio',
    'AIzaSyB9wdGlhGGpUc3hEyqWvu3ssdEgBYssrY8',
    'AIzaSyBzs7qBsOX5Sjn6MP1HK9GgKHTkqG5UsHA',
    'AIzaSyD107BUvArrYl_o2GBq--l8JisDMFKdH6E',
    'AIzaSyDd6kWvqY2eYZW-JR7XET_uVRKNyUTi2aA',
    'AIzaSyD1y2H_wUMAnLKn-4ZHThPzCqpwDGmenZo',
    'AIzaSyCvI1BiQT265LxvM9jA9BmBuXuGGyLzOMk',
    'AIzaSyAGUpRlb8ZoqUcHJv4RaDtwT65cYLtpmrM',
    'AIzaSyDFivxbzvntZ1R2qMDOLrb3PDRxra3mqJo',
    'AIzaSyBgs9sLmOl0kr_DW3ROGnGmg4GEkZXRZL4',
    'AIzaSyC3ikbnHzqxyHkVHtI7aooBXTbItkj8Aik',
    'AIzaSyBs_jh18vdJvjaFt2z0BNldMQHfU_7HLQo',
    'AIzaSyBDSeJqM-_zkWUi1nzqosBISDuiPYKIPac',
    'AIzaSyACqgY8aEXlgCD2FV9oWNyk3m2JlRQDpDE',
    'AIzaSyATJlmLGyigO0ZaWSzl_XIFIrpIonMWsRM',
    'AIzaSyAgqJs7luJuRGZTIdurny97TLF4pAlCBno',
    'AIzaSyAa4cjDIzteWaEHoGhFbUm_8B5-J_UMeE4',
    'AIzaSyAY_poT5Zoa--CTqf52y2k1IsnJzwXx7NQ',
    'AIzaSyAbgOkEUvHm1WnGa6r3aH8DT8Uv5DhgXTM',
    'AIzaSyDg1ubvWUgCiamixf9KyzAKJliZaAMKfkw',
    'AIzaSyA7lkJ1mqaeg-J4r5IiLXxkjTq7gP5T2fU',
    'AIzaSyDMxu0xA-o7mTdNL0AXmIn810KVCAral_M',
    'AIzaSyCvCzF3DMJM4AZs-ZQgyuzu3rgQyjbMn48',
    'AIzaSyAc737uNkUxzl5XFLnMq6MYt1IU4OPnUyQ',
    'AIzaSyAMuw9XORmOc8aPrUtkE2ItJ6QBbqBgzNY',
    'AIzaSyDr0zhm3Xxi2nGhlexNTa_lewHG1DYLWbg',
    'AIzaSyCH-lNzywOg56rLJIXbSF-UrLbYZ-bGSnE',
    'AIzaSyCUJwu8gadHdsQuDSfNOXyYeQ92BUjK3kM',
    'AIzaSyCGh9ppJQaTie7IJPoS8kqIXVjEpd0nmFs',
    'AIzaSyCW1jF_Zj5iMOSAuZxBnheVOgRDHQAyYHo',
];

export const YOUTUBE_DEFAULT_VALUE = {
    views: {
        price: 7.93,
        quantity: 1000,
        discount: 0.07,
        // price: 0,
        // quantity: 0,
        // discount: 0,
        start: 0,
    },
    watchhours: {
        price: 22.99,
        quantity: 250,
        discount: 1.99,
        // price: 0,
        // quantity: 0,
        // discount: 0,
        start: 0,
    },
    shares: {
        price: 5.24,
        quantity: 750,
        discount: 0.01,
        // price: 0,
        // quantity: 0,
        // discount: 0,
        start: 0,
    },
    likes: {
        price: 7.63,
        quantity: 100,
        discount: 0.01,
        // price: 0,
        // quantity: 0,
        // discount: 0,
        start: 0,
    },
    subscribers: {
        price: 9.33,
        quantity: 80,
        discount: 0.27,
        // price: 0,
        // quantity: 0,
        // discount: 0,
        start: 0,
    },
    dedicatedComments: {
        price: 3.99,
        quantity: 10,
        discount: 0.07,
        // price: 0,
        // quantity: 0,
        // discount: 0,
        start: 0,
    },
};
